const CORRECT = 'correct-answer';
export default CORRECT;
